import { createSelector } from "reselect";
import moment from "moment";
import "moment/locale/es";
import { ROLES_RAW } from "../../constants/permissions";
moment().locale("es");

/* APP */
export const isUserAuthorized = createSelector(
  (state) => state.authorization,
  (authorization) => authorization
);
export const getCurrentRoute = createSelector(
  (state) => state.currentRoute,
  (currentRoute) => currentRoute
);
export const getCurrentRouteTitle = createSelector(
  getCurrentRoute,
  (route) => route.title
);
export const getSideMenuState = createSelector(
  (state) => state.app,
  (app) => app.isCollapsedSideMenu
);
export const getCurrentTheme = createSelector(
  (state) => state.currentTheme,
  (currentTheme) => currentTheme
);

/* PROFILE */
export const getUserProfile = createSelector(
  (state) => state.profile,
  (profile) => profile
);
export const currentUserId = createSelector(
  (state) => state.profile,
  (profile) => profile && profile.id
);
export const getCurrentUserRole = createSelector(getUserProfile, (profile) =>
  !profile ? null : ROLES_RAW.includes(profile.role) ? profile.role : null
);

/* NOTIFICATIONS STATE */
export const getNotificationsState = createSelector(
  (state) => state.notifications,
  (notifications) => notifications
);

/* USERS */
export const getUsers = createSelector(
  (state) => state.users,
  (users) => users
);
export const getUsersForm = createSelector(
  (state) => state.usersForm,
  (form) => form
);

/* ALERT */
export const getAlerts = createSelector(
  (state) => state.alerts,
  (alerts) => alerts
);
export const getAlertsForm = createSelector(
  (state) => state.alertsForm,
  (form) => form
);

/* CUSTOMERS */
export const getCustomers = createSelector(
  (state) => state.customers,
  (customers) => customers
);
export const getCustomersForm = createSelector(
  (state) => state.customersForm,
  (form) => form
);

/* LAUNDRYS */
export const getLaundrys = createSelector(
  (state) => state.laundrys,
  (laundrys) => laundrys
);
export const getLaundrysForm = createSelector(
  (state) => state.laundrysForm,
  (form) => form
);

/* MACHINES */
export const getMachines = createSelector(
  (state) => state.machines,
  (machines) => machines
);
export const getMachinesForm = createSelector(
  (state) => state.machinesForm,
  (form) => form
);

/* CALIBRATION */
export const getCalibrationForm = createSelector(
  (state) => state.calibrationForm,
  (form) => form
);

/* PROGRAMS */
export const getProgramsForm = createSelector(
  (state) => state.programsForm,
  (form) => form
);

/* DOSIFICATIONS */
export const getDosificationsForm = createSelector(
  (state) => state.dosificationsForm,
  (form) => form
);
